import { ColumnProps } from '#/common/components/DataGrid';
import { withChip } from '#/common/utils/wrappers';
import { Alert } from '#/graphql/types';
import { gql } from '@apollo/client';
import { alertStateColors, states, statesList } from '../../utils/constants';
import { getTenantList } from '#/graphql/queries';

export const columns: ColumnProps<Alert>[] = [
  {
    dataField: 'id',
    caption: 'ID',
    visible: false,
    dataType: 'string',
    showInColumnChooser: false,
  },
  {
    dataField: 'displayNumber',
    caption: 'Display Number',
    dataType: 'string',
    fixed: true,
    visible: true,
    openOnClick: true,
  },
  {
    dataField: 'asset.assetTag',
    caption: 'Device Name',
    dataType: 'string',
    visible: true,
  },
  {
    dataField: 'firstException',
    caption: 'First Exception',
    dataType: 'date',
    visible: true,
  },
  {
    dataField: 'worstException',
    caption: 'Worst Exception',
    dataType: 'date',
    visible: true,
  },
  {
    dataField: 'lastException',
    caption: 'Latest Exception',
    dataType: 'date',
    visible: true,
    sortIndex: 0,
    sortOrder: 'desc',
  },
  {
    dataField: 'state',
    caption: 'Status',
    dataType: 'string',
    visible: true,
    lookup: {
      nullable: true,
      dataSource: statesList,
      displayExpr: 'text',
      valueExpr: 'value',
    },
    cellRender: (e) => {
      if (!e.value) {
        return null;
      }
      const customColors = alertStateColors[e.value as string];
      return withChip(e.displayValue || '', 'normal', customColors);
    },
  },
  {
    dataField: 'impactComfort',
    caption: 'Comfort Impact',
    dataType: 'string',
    visible: true,
  },
  {
    dataField: 'impactEnergy',
    caption: 'Energy Impact',
    dataType: 'string',
    visible: true,
  },
  {
    dataField: 'impactReliability',
    caption: 'Reliability Impact',
    dataType: 'string',
    visible: true,
  },
  {
    dataField: 'exceptionName',
    caption: 'Exception Name',
    dataType: 'string',
    visible: true,
  },
  {
    dataField: 'number',
    caption: 'Number',
    dataType: 'string',
    visible: false,
  },
  {
    dataField: 'daysFailed',
    caption: 'Days Failed',
    dataType: 'string',
    visible: false,
  },
  {
    dataField: 'tisStatus',
    caption: 'TIS Status',
    dataType: 'string',
    visible: false,
  },
  {
    dataField: 'testValue',
    caption: 'Test Value',
    dataType: 'string',
    visible: false,
  },
  {
    dataField: 'suggestionDescription',
    caption: 'Suggestion',
    dataType: 'string',
    visible: false,
  },
  {
    dataField: 'workOrder.displayNumber',
    caption: 'Work Order',
    dataType: 'string',
    visible: false,
  },
  {
    dataField: 'finding.displayNumber',
    caption: 'Finding',
    dataType: 'string',
    visible: false,
  },
  {
    dataField: 'tenant.name',
    caption: 'Organization',
    visible: false,
    dataType: 'string',
    headerFilter: {
      getItemList: gql(getTenantList),
      displayExpr: 'name',
    },
  },
  { dataField: 'thirdPartyId', caption: 'Third Party ID', dataType: 'string', visible: false },
  {
    dataField: 'thirdPartySource',
    caption: 'Third Party Source',
    dataType: 'string',
    visible: false,
  },
  { dataField: 'createdAt', caption: 'Created At', dataType: 'date', visible: false },
  { dataField: 'createdBy', caption: 'Created By', dataType: 'string', visible: false },
  { dataField: 'updatedAt', caption: 'Updated At', dataType: 'date', visible: false },
  { dataField: 'updatedBy', caption: 'Updated By', dataType: 'string', visible: false },
];
